(function () {
  if (window.floofGrouptifyCurrencyLoaded) return;
  window.floofGrouptifyCurrencyLoaded = true;

  const PRICE_SELECTOR = '.mpb-offer__price-current';

  let groupContainer = null;
  let bucksPrice = null;
  let updateFrame = null;
  let isUpdating = false;


  function parseNumber(value) {
    const number = parseFloat(
      String(value || '')
        .replace(/,/g, '')
        .replace(/[^\d.-]/g, '')
    );

    return Number.isFinite(number)
      ? number
      : null;
  }


  /*
   * Find any price BUCKS has already
   * successfully converted.
   */
  function findBucksPrice() {
    const prices = document.querySelectorAll(
      '.buckscc-converted[bucks-init][bucks-current][bucks-currency]'
    );

    for (const price of prices) {
      const original = parseNumber(
        price.getAttribute('bucks-init')
      );

      const converted = parseNumber(
        price.getAttribute('bucks-current')
      );

      const currency =
        price.getAttribute('bucks-currency');

      if (
        original &&
        converted &&
        currency
      ) {
        return price;
      }
    }

    return null;
  }


  function getConversion() {
    if (
      !bucksPrice ||
      !document.documentElement.contains(bucksPrice)
    ) {
      bucksPrice = findBucksPrice();
    }

    if (!bucksPrice) return null;

    const original = parseNumber(
      bucksPrice.getAttribute('bucks-init')
    );

    const converted = parseNumber(
      bucksPrice.getAttribute('bucks-current')
    );

    const currency =
      bucksPrice.getAttribute('bucks-currency');

    if (
      !original ||
      !converted ||
      !currency
    ) {
      return null;
    }

    return {
      rate: converted / original,
      currency: currency
    };
  }


  function formatMoney(amount, currency) {
    try {
      return (
        new Intl.NumberFormat(
          currency === 'AUD'
            ? 'en-AU'
            : 'en-US',
          {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        ).format(amount) +
        ' ' +
        currency
      );
    } catch (error) {
      return (
        '$' +
        amount.toFixed(2) +
        ' ' +
        currency
      );
    }
  }


  function updatePrices() {
    if (isUpdating) return;

    const conversion = getConversion();

    if (!conversion) return;

    const prices =
      document.querySelectorAll(
        PRICE_SELECTOR
      );

    if (!prices.length) return;

    isUpdating = true;

    prices.forEach(function (price) {
      /*
       * Grouptify may recreate the element.
       * Whenever we see a fresh USD value,
       * save that as the source price.
       */
      const visibleText =
        price.textContent.trim();

      let usd =
        parseNumber(
          price.getAttribute(
            'data-floof-usd'
          )
        );


      /*
       * If Grouptify has just repainted this
       * element back to USD, capture the new
       * USD amount.
       */
      const currentlyConverted =
        price.getAttribute(
          'data-floof-converted'
        ) === 'true';

      if (
        !currentlyConverted ||
        visibleText.indexOf(
          conversion.currency
        ) === -1
      ) {
        const freshValue =
          parseNumber(visibleText);

        if (freshValue !== null) {
          usd = freshValue;

          price.setAttribute(
            'data-floof-usd',
            String(freshValue)
          );
        }
      }


      if (usd === null) return;

      const convertedAmount =
        usd * conversion.rate;

      const desiredText =
        formatMoney(
          convertedAmount,
          conversion.currency
        );


      if (
        price.textContent.trim() !==
        desiredText
      ) {
        price.textContent =
          desiredText;
      }

      price.setAttribute(
        'data-floof-converted',
        'true'
      );
    });

    isUpdating = false;
  }


  function queueUpdate() {
    if (updateFrame) {
      cancelAnimationFrame(
        updateFrame
      );
    }

    updateFrame =
      requestAnimationFrame(
        function () {
          updateFrame = null;
          updatePrices();
        }
      );
  }


  /*
   * Wait briefly for Grouptify + BUCKS.
   */
  let attempts = 0;

  const loader =
    setInterval(function () {
      attempts++;

      const firstPrice =
        document.querySelector(
          PRICE_SELECTOR
        );

      bucksPrice =
        findBucksPrice();

      if (
        firstPrice &&
        bucksPrice
      ) {
        clearInterval(loader);

        groupContainer =
          firstPrice.closest(
            '.mp-bundle'
          ) ||
          firstPrice.parentElement;

        updatePrices();


        /*
         * Grouptify redraws its own prices.
         * Watch ONLY its bundle area.
         */
        if (groupContainer) {
          const groupObserver =
            new MutationObserver(
              function () {
                if (!isUpdating) {
                  queueUpdate();
                }
              }
            );

          groupObserver.observe(
            groupContainer,
            {
              childList: true,
              subtree: true,
              characterData: true
            }
          );
        }


        /*
         * If BUCKS changes its live rate
         * or selected currency, update again.
         */
        const bucksObserver =
          new MutationObserver(
            function () {
              queueUpdate();
            }
          );

        bucksObserver.observe(
          bucksPrice,
          {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
            attributeFilter: [
              'bucks-current',
              'bucks-init',
              'bucks-currency'
            ]
          }
        );

        return;
      }


      /*
       * Stop trying after 10 seconds.
       */
      if (attempts >= 50) {
        clearInterval(loader);
      }
    }, 200);

})();